$(function() {
 
    $(window).on("scroll", function() {
        if ($(this).scrollTop() > 100) {
            $(".float-button__wrap").fadeIn(300);
            } else {
            $(".float-button__wrap").fadeOut(300);
        }
 
        const scrollHeight = $(document).height();/*ページ全体の高さ*/
        const scrollPosition = $(window).height() + $(window).scrollTop();/*ページの一番上からスクロールされた距離*/
        const footHeight = $("footer").height();/*フッターの高さ*/
 
        if ( scrollHeight - scrollPosition  <= footHeight ) {
            $(".float-button__wrap").css({
                "position":"absolute",
                "bottom": 10  + footHeight,
            });
        } else {
            $(".float-button__wrap").css({
                "position":"fixed",
                "bottom": "10px",
            });
        }
    });
 
});